import { z } from "zod";
import { UIElementType } from "../../../AppConstants";
import { t } from "i18next";

const getItineraryTimesSchema = (deviceTypeData, itineraryTimesId = null) => {
  return z.object({
    DeviceType: z
      .object({
        id: z.string(),
        label: z.string(),
      })
      .nullable()
      .refine((value) => value !== null && value?.id !== null, {
        message: "Device type is required",
      })
      .describe(
        JSON.stringify({
          elementType: UIElementType.DROPDOWN,
          inputLabel: t("createDevice.deviceType"),
          isMultiSelect: false,
          isRequired: true,
          options: deviceTypeData,
          isDisabled: !!itineraryTimesId,
        })
      ),
    Jorney: z
      .string()
      .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("itineraryTimesList.jorney"), isRequired: false })),
    Percentage1: z
      .number()
      .refine(value => value === null || value >= 0, {
        message: "If entered, the number must be positive or zero",
      })
      .describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("itineraryTimesList.percentage1"), isRequired: true })),
    Percentage2: z
      .number()
      .refine(value => value === null || value >= 0, {
        message: "If entered, the number must be positive or zero",
      })
      .describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("itineraryTimesList.percentage2"), isRequired: true }))

  });
};

const getItineraryTimesDefaultValue = (value = null) => {
  return {
    DeviceType: value ? value?.DeviceType : null,
    Jorney: value ? value?.Jorney : "",
    Percentage1: value ? value?.Percentage1 : null,
    Percentage2: value ? value?.Percentage2 : null,
  };
};

const getItineraryTimesAPIPostSchema = (countryCode, businessCode) => {
  return {
    countryCode: countryCode,
    businessCode: businessCode,
    itineraryTimes: [
      {
        ItineraryTimesId: "",
        DeviceTypeId: null,
        Jorney: null,
        StartRange: 1,
        EndRange: 999999,
        Measurement: "unid",
        Percentage1: null,
        Percentage2: null,
        Deleted: false,
        CountryCode: countryCode,
        BusinessCode: businessCode,
      },
    ],
  };
};

const getItineraryTimesAuditInfoSchema = () => {
  return {
    auditInfo: [
      {
        Location: "Itinerary Times",
        LocationKey: "",
        Action: null,
        shortDesc: null,
        currentState: null,
        previousState: null,
      },
    ],
  };
};

const getItineraryTimesAPIDeleteSchema = (countryCode, businessCode) => {
  return {
    countryCode: countryCode,
    businessCode: businessCode,
    itineraryTimes: [
      {
        ItineraryTimesId: "",
        Deleted: true,
        CountryCode: countryCode,
        BusinessCode: businessCode
      },
    ],
  };
};

export { getItineraryTimesSchema, getItineraryTimesDefaultValue, getItineraryTimesAPIPostSchema, getItineraryTimesAuditInfoSchema, getItineraryTimesAPIDeleteSchema };
